module.exports = __webpack_public_path__ + "static/media/platform_mannual.c3d26a8c.md";